module.exports = __webpack_public_path__ + "img/GB.ca2c8466.svg";